import React, { PropTypes, Component } from 'react';
import classNames from 'classnames'

import InfiniteScroll from '../../controls/infiniteScroll';
import Image from '../../controls/image/Image.jsx';
import { getIcon } from 'pluton-core/lib/services/core/alerts/alerts.helper';

class BaseDetails extends Component {

    renderTitle = (date) => {
        return (
            <div className="alerts__date">
                {date}
            </div>
        );
    };

    renderIcon = (groupedItem) => {
        const image = getIcon(groupedItem);
        if (image) {
            return (
                <Image className="alert__icon"
                       imgClassName="icon"
                       src={image}/>
            );
        }

        return null;
    };

    renderBody = (dateGroupedItem) => {
    };

    render() {
        const {
            details: {
                dateGroupedItems
            },
            handleGetPrev,
            handleGetNext,
            showImportant
        } = this.props;

        if (!dateGroupedItems || !dateGroupedItems.length) {
            return null;
        }

        const groupDetailsView = dateGroupedItems
            .map((dateGroupedItem, dateGroupedItemIndex) => {
                return (
                    <div ref={`${dateGroupedItem.dateGroup}`}
                         key={dateGroupedItemIndex}
                         className='alert-wrap'>
                        {this.renderTitle(dateGroupedItem.dateGroup)}
                        {this.renderBody(dateGroupedItem)}
                    </div>
                );
            });

        const classNamesObj = classNames({
            'alerts': true,
            'alerts--important': showImportant
        });

        return (
            <div ref="alerts"
                 className={classNamesObj}>
                <InfiniteScroll
                    ref="scroll"
                    isLoading={this.props.details.isLoading}
                    loader={<div></div>}
                    prev={handleGetPrev}
                    next={handleGetNext}
                    hasMore={true}>
                    {groupDetailsView}
                </InfiniteScroll>
            </div>
        );
    }
}

BaseDetails.propTypes = {
    alertModel: PropTypes.func,
    date: PropTypes.object,
    showImportant: PropTypes.bool,

    details: PropTypes.object,
    handleGetPrev: PropTypes.func,
    handleGetNext: PropTypes.func,

    handleSetAlertToJump: PropTypes.func,
};

export default BaseDetails;



// WEBPACK FOOTER //
// ./app/components/custom/details/BaseDetails.jsx